/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Shipping_AddressInputs */

const vi_order_shipping_address = /** @type {(inputs: Order_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ giao`)
};

/**

* @param {Order_Shipping_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_shipping_address = /** @type {((inputs?: Order_Shipping_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Shipping_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_shipping_address(inputs)
});